import { Divider, Typography, IconButton } from '@mui/material';
import ChevronLeft from '@mui/icons-material/ChevronLeftTwoTone';
import ChevronRight from '@mui/icons-material/ChevronRightTwoTone';
import ExpandLess from '@mui/icons-material/ExpandLessTwoTone';
import { SetStateAction } from 'react';

import styles from './NavigationBarFooter.module.css';
import { MobileMenuProps } from './types';

type NavigationBarFooterProps = MobileMenuProps & {
	isMobile: boolean;
	isDesktopOpen: boolean;
	setDesktopOpen: React.Dispatch<SetStateAction<boolean>>;
};

export default function NavigationBarFooter(props: NavigationBarFooterProps) {
	const FooterIcon = () => {
		if (props.isMobile) {
			return <ExpandLess />;
		}

		if (props.isDesktopOpen) {
			return <ChevronLeft />;
		}

		return <ChevronRight />;
	};

	const toggleMenu = () => {
		if (props.isMobile) {
			props.setMobileMenuOpen(!props.mobileMenuOpen);
		} else {
			props.setDesktopOpen(!props.isDesktopOpen);
		}
	};

	return (
		<div className={styles['navigation-bar-footer']}>
			<Divider className={styles['navigation-bar-footer-divider']} />

			<div className={`${styles['navigation-bar-footer-content']} ${props.isDesktopOpen || props.isMobile ? styles.open : styles.closed}`}>
				<Typography
					variant='caption'
					className={styles['navigation-bar-footer-text']}
					title={props.isDesktopOpen ? '' : `v${NPM_PACKAGE_VERSION}`}
				>
					{props.isDesktopOpen || props.isMobile ? `v${NPM_PACKAGE_VERSION}` : `v${NPM_PACKAGE_VERSION.split('.', 2).join('.')}`}
				</Typography>

				<IconButton onClick={toggleMenu}>
					<FooterIcon />
				</IconButton>
			</div>
		</div>
	);
}
